import { DateTimePicker as MUIDateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment-timezone";
import { FormikProps, getIn } from 'formik';
import { Box, FormHelperText } from '@mui/material';

interface DateTimePickerProps {
    formik?: FormikProps<any>
    formikFieldName?: string;
    datetimeValue: moment.Moment | null;
    handleChange: (newValue: moment.Moment) => void;
    pickerLabel: string;
    minDate?: moment.Moment | null;
    maxDate?: moment.Moment | null;
}

const DateTimePicker = ({formik, formikFieldName, datetimeValue, handleChange, pickerLabel, minDate, maxDate }: DateTimePickerProps) => {
    return (
        <Box sx={{ marginTop: '10px' }}>
            <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale='en-US'
            >
                <MUIDateTimePicker
                    label={pickerLabel}
                    value={datetimeValue}
                    onChange={handleChange}
                    ampm={false}
                    minDateTime={minDate || undefined}
                    maxDateTime={maxDate || undefined}
                    disablePast={!minDate}
                    sx={{ width: '100%' }}
                    slotProps={{
                        textField: {
                            onKeyDown: (e) => e.preventDefault(),
                            className: 'input-text',
                            error: (getIn(formik.touched, formikFieldName) && Boolean(getIn(formik.errors, formikFieldName))) ?? false,
                        },
                    }}
                />
            </LocalizationProvider>
            {formik && formikFieldName && getIn(formik.touched, formikFieldName) && getIn(formik.errors, formikFieldName) && (
            <FormHelperText error>
                {getIn(formik.errors, formikFieldName)}
            </FormHelperText>
            )}
        </Box>

    )
}

export { DateTimePicker };
